import { render, staticRenderFns } from "./GroupScheduleExams.vue?vue&type=template&id=19c263ef&"
import script from "./GroupScheduleExams.vue?vue&type=script&lang=js&"
export * from "./GroupScheduleExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports